export default [
    {
        path: 'relatorio-usuario',
        component: () => import(
            /* webpackChunkName: 'cadastro-relatorio-usuario' */
            '@/views/cadastro/relatorio-usuario/Index'
        ),
        redirect: 'relatorio-usuario/index',
        children: [
            {
                name: 'cadastro-relatorio-usuario-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-relatorio-usuario' */
                    '@/views/cadastro/relatorio-usuario/List.vue'
                ),
            },
        ],
    },
]